export default {
  pairCoinScales: {},
};
